import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca073b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "checked", "disabled"]
const _hoisted_2 = ["for"]

import { PropType } from 'vue'
import BaseIcon from '@/components/BaseIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  color: {
    type: String,
    default: undefined,
  },
  checkColor: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RequiredAsterisk = _resolveComponent("RequiredAsterisk")!
  const _component_InputErrorMessages = _resolveComponent("InputErrorMessages")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'checkbox__wrapper',
      __props.modelValue && 'checkbox__wrapper--checked',
      __props.disabled && 'checkbox__wrapper--disabled',
    ]),
    style: _normalizeStyle({ '--checkbox-color': __props.color })
  }, [
    (__props.modelValue)
      ? (_openBlock(), _createBlock(BaseIcon, {
          key: 0,
          class: "checkbox__check",
          style: _normalizeStyle({ '--check-color': __props.checkColor }),
          icon: "check",
          height: 16,
          width: 16
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: __props.name,
      class: "checkbox__input",
      type: "checkbox",
      name: __props.name,
      checked: __props.modelValue,
      disabled: __props.disabled
    }, null, 8, _hoisted_1),
    _createElementVNode("label", {
      class: "checkbox__label",
      for: __props.name
    }, [
      _renderSlot(_ctx.$slots, "label", { label: __props.label }, () => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      (__props.required)
        ? (_openBlock(), _createBlock(_component_RequiredAsterisk, { key: 0 }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(_component_InputErrorMessages, { "model-value": __props.errors }, null, 8, ["model-value"])
  ], 6))
}
}

})